// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanDeleteWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

interface DeleteParams {
  floorPlanId: string;
}

export interface RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete_Args
>;

/**
 * Delete floor plan of a property
 * @deprecated
 */
export const useRentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyFloorPlanDeleteWebApiHandler_delete(args.getParams, httpClient),
  });
};
